/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: BwqJSXeefC40
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import ProgressBar from "../../ProgressBar"; // plasmic-import: eWV8ME8zaoyc/component
import NativeContainer from "../../NativeContainer"; // plasmic-import: dotM4jJPGxS5/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: cGXW91A7jag-/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: mqAYXqPyOASe/component
import FormElement from "../../FormElement"; // plasmic-import: ncxDEJ0p8q40/component
import InputField from "../../InputField"; // plasmic-import: pjd8dJIhANlZ/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebLogin.module.css"; // plasmic-import: BwqJSXeefC40/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p login.",
    openGraph: {
      title: "o21p login."
    },
    twitter: {
      card: "summary",
      title: "o21p login."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebLogin__VariantProps = new Array();

export const PlasmicWebLogin__ArgProps = new Array();

const $$ = {};

function PlasmicWebLogin__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "insideOnboarding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.insideOnboarding
      },
      {
        path: "onboardingContainer.container",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "withForm"
      },
      {
        path: "usernameOrEmail",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "password",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "pswdState",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "userState",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "pswdHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "usernameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "pswdHelperOnOff",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "usernameHelperOnOff",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "loginOk",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => true
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageLogin"}
        data-plasmic-override={overrides.pageLogin}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageLogin
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              dockSection={false}
              tabContent={
                <React.Fragment>
                  <ProgressBar
                    data-plasmic-name={"progressBar"}
                    data-plasmic-override={overrides.progressBar}
                    className={classNames("__wab_instance", sty.progressBar)}
                  />

                  <NativeContainer
                    data-plasmic-name={"onboardingContainer"}
                    data-plasmic-override={overrides.onboardingContainer}
                    buttonsWrapper={
                      <React.Fragment>
                        <ButtonPrimary
                          className={classNames(
                            "__wab_instance",
                            sty.buttonPrimary__lDpbp
                          )}
                          color={"brand"}
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToPWorkspace"] = true
                              ? (() => {
                                  const actionArgs = {
                                    destination: `/aaa/workspace`
                                  };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToPWorkspace"] != null &&
                              typeof $steps["goToPWorkspace"] === "object" &&
                              typeof $steps["goToPWorkspace"].then ===
                                "function"
                            ) {
                              $steps["goToPWorkspace"] =
                                await $steps["goToPWorkspace"];
                            }
                          }}
                        />

                        {false ? (
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__eukOx
                            )}
                          />
                        ) : null}
                      </React.Fragment>
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.onboardingContainer
                    )}
                    container={generateStateValueProp($state, [
                      "onboardingContainer",
                      "container"
                    ])}
                    formHeader={"welcome back!"}
                    formWrapper={
                      <InputFormShell
                        data-plasmic-name={"inputFormShell"}
                        data-plasmic-override={overrides.inputFormShell}
                        actionsSlot={
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__eZhyV
                            )}
                            color={"brand"}
                            content={"log in"}
                            name={"johnTheLogMaster"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["runCode"] = true
                                ? (() => {
                                    const actionArgs = {
                                      customFunction: async () => {
                                        return (() => {
                                          let username = document
                                            .getElementById("username")
                                            .value.trim();
                                          let pswd = document
                                            .getElementById("pswd")
                                            .value.trim();
                                          console.log(
                                            "username: ",
                                            username,
                                            " password: ",
                                            pswd
                                          );
                                          console.log($state.loginOk);
                                          if (username === "") {
                                            $state.userState = "error";
                                            $state.usernameHelperOnOff = true;
                                            $state.usernameHelperText =
                                              "This field is required.";
                                          }
                                          if (pswd === "") {
                                            $state.pswdState = "error";
                                            $state.pswdHelperOnOff = true;
                                            return ($state.pswdHelperText =
                                              "This field is required.");
                                          }
                                        })();
                                      }
                                    };
                                    return (({ customFunction }) => {
                                      return customFunction();
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["runCode"] != null &&
                                typeof $steps["runCode"] === "object" &&
                                typeof $steps["runCode"].then === "function"
                              ) {
                                $steps["runCode"] = await $steps["runCode"];
                              }
                              $steps["sendToBackend"] = true
                                ? (() => {
                                    const actionArgs = {
                                      customFunction: async () => {
                                        return (async function () {
                                          const username = document
                                            .getElementById("username")
                                            .value.trim();
                                          const pswd = document
                                            .getElementById("pswd")
                                            .value.trim();
                                          console.log(
                                            "user/pswd: ",
                                            username,
                                            pswd
                                          );
                                          try {
                                            const response = await fetch(
                                              "https://opformypractice.com/api/login/",
                                              {
                                                method: "POST",
                                                headers: {
                                                  "Content-Type":
                                                    "application/json"
                                                },
                                                body: JSON.stringify({
                                                  username,
                                                  password: pswd
                                                }),
                                                credentials: "include"
                                              }
                                            );
                                            if (response.ok) {
                                              const data =
                                                await response.json();
                                              console.log(
                                                "Login successful! Welcome " +
                                                  data.username
                                              );
                                              $state.loginOk = true;
                                            } else {
                                              $state.loginOk = false;
                                              const error =
                                                await response.json();
                                              console.log(
                                                "Login failed: " + error.detail
                                              );
                                              if (
                                                error.detail ===
                                                "Invalid username"
                                              ) {
                                                $state.pswdHelperOnOff = true;
                                                $state.pswdHelperText =
                                                  "Username or password invalid. Please try again";
                                                $state.userState = "error";
                                              } else if (
                                                error.detail ===
                                                "Invalid password"
                                              ) {
                                                $state.pswdHelperOnOff = true;
                                                $state.pswdHelperText =
                                                  "Username or password invalid. Please try again";
                                                $state.pswdState = "error";
                                              } else {
                                                $state.pswdHelperOnOff = true;
                                                $state.pswdHelperText =
                                                  "Something went wrong, please try again";
                                                $state.pswdState = "error";
                                              }
                                            }
                                          } catch (err) {
                                            console.error(
                                              "Network error:",
                                              err
                                            );
                                            console.log(
                                              "Network error: " + err.message
                                            );
                                          }
                                        })();
                                      }
                                    };
                                    return (({ customFunction }) => {
                                      return customFunction();
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["sendToBackend"] != null &&
                                typeof $steps["sendToBackend"] === "object" &&
                                typeof $steps["sendToBackend"].then ===
                                  "function"
                              ) {
                                $steps["sendToBackend"] =
                                  await $steps["sendToBackend"];
                              }
                              $steps["goToPWorkspace"] = $state.loginOk
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/pro/workspace`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPWorkspace"] != null &&
                                typeof $steps["goToPWorkspace"] === "object" &&
                                typeof $steps["goToPWorkspace"].then ===
                                  "function"
                              ) {
                                $steps["goToPWorkspace"] =
                                  await $steps["goToPWorkspace"];
                              }
                            }}
                            showIcon={false}
                            size={"medium"}
                            ststus={"normal"}
                            type={"button"}
                          />
                        }
                        className={classNames(
                          "__wab_instance",
                          sty.inputFormShell
                        )}
                        fieldsSlot={
                          <React.Fragment>
                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__l9MB
                              )}
                              formInputComponent={
                                <InputField
                                  className={classNames(
                                    "__wab_instance",
                                    sty.inputField__ck9Iz
                                  )}
                                  inputId={"username"}
                                  placeholder={``}
                                  status={(() => {
                                    try {
                                      return $state.userState;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "normal";
                                      }
                                      throw e;
                                    }
                                  })()}
                                  type={"text"}
                                  valueInput={(() => {
                                    try {
                                      return $state.usernameOrEmail;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.usernameHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"username."}
                              name={"usernameOrEmail"}
                              required={true}
                              showHelperText={(() => {
                                try {
                                  return $state.usernameHelperOnOff;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.userState;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />

                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__xr7WS
                              )}
                              formInputComponent={
                                <InputField
                                  className={classNames(
                                    "__wab_instance",
                                    sty.inputField__cewhf
                                  )}
                                  inputId={"pswd"}
                                  status={(() => {
                                    try {
                                      return $state.pswdState;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "normal";
                                      }
                                      throw e;
                                    }
                                  })()}
                                  type={"password"}
                                  valueInput={(() => {
                                    try {
                                      return $state.password;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.pswdHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"password."}
                              name={"password"}
                              required={true}
                              showHelperText={(() => {
                                try {
                                  return $state.pswdHelperOnOff;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.pswdState;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />
                          </React.Fragment>
                        }
                        layout={"_default"}
                      />
                    }
                    infotextWrapper2={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__tIxKh
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"Don't have an o21p workspace account? "}
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                            }
                            style={{ color: "var(--token-jyNQAasUGv4X)" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              data-plasmic-name={"link"}
                              data-plasmic-override={overrides.link}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.a__fRuRb,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link
                              )}
                              href={`/signup`}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {"sign up free"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                            }
                            style={{ color: "var(--token-jyNQAasUGv4X)" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                    }
                    onContainerChange={async (...eventArgs) => {
                      generateStateOnChangeProp($state, [
                        "onboardingContainer",
                        "container"
                      ]).apply(null, eventArgs);
                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }
                    }}
                    showHelperText={true}
                    text={
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__kTdw
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {"We\u2019ve sent a message with a link to "}
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                              }
                              style={{ color: "#000000", fontWeight: 600 }}
                            >
                              {"john@email.com"}
                            </span>
                            <React.Fragment>
                              {" to verify your email."}
                            </React.Fragment>
                          </React.Fragment>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___3N8G7
                          )}
                        >
                          {
                            "This link expires in 24 hours.\nDidn't receive an email? Check your spam folder."
                          }
                        </div>
                      </React.Fragment>
                    }
                    text2={
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__cPcQl
                          )}
                        >
                          {"that\u2019s it, you\u2019re in."}
                        </div>
                        {false ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__gMunB
                            )}
                          >
                            {"You\u2019ve successfully created you OP account."}
                          </div>
                        ) : null}
                      </React.Fragment>
                    }
                  >
                    <ButtonPrimary
                      color={"brand"}
                      content={"try again"}
                      onClick={async () => {
                        const $steps = {};
                        $steps["goToWebLogin"] = true
                          ? (() => {
                              const actionArgs = { destination: `/login` };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToWebLogin"] != null &&
                          typeof $steps["goToWebLogin"] === "object" &&
                          typeof $steps["goToWebLogin"].then === "function"
                        ) {
                          $steps["goToWebLogin"] = await $steps["goToWebLogin"];
                        }
                      }}
                      size={"medium"}
                      ststus={"normal"}
                      type={"button"}
                    />
                  </NativeContainer>
                </React.Fragment>
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <ButtonSecondary
                      data-plasmic-name={"buttonSecondary"}
                      data-plasmic-override={overrides.buttonSecondary}
                      className={classNames(
                        "__wab_instance",
                        sty.buttonSecondary
                      )}
                      color={"primary"}
                      content={"x"}
                      onClick={async () => {
                        const $steps = {};
                        $steps["goToWebWorkspace"] = true
                          ? (() => {
                              const actionArgs = { destination: `/workspace` };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToWebWorkspace"] != null &&
                          typeof $steps["goToWebWorkspace"] === "object" &&
                          typeof $steps["goToWebWorkspace"].then === "function"
                        ) {
                          $steps["goToWebWorkspace"] =
                            await $steps["goToWebWorkspace"];
                        }
                      }}
                    />
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p login."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageLogin: [
    "pageLogin",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  webTab: [
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  webTopNav: ["webTopNav", "breadcrumb", "buttonSecondary"],
  breadcrumb: ["breadcrumb"],
  buttonSecondary: ["buttonSecondary"],
  progressBar: ["progressBar"],
  onboardingContainer: ["onboardingContainer", "inputFormShell", "link"],
  inputFormShell: ["inputFormShell"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebLogin__ArgProps,
          internalVariantPropNames: PlasmicWebLogin__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebLogin__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageLogin") {
    func.displayName = "PlasmicWebLogin";
  } else {
    func.displayName = `PlasmicWebLogin.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebLogin = Object.assign(
  // Top-level PlasmicWebLogin renders the root element
  withUsePlasmicAuth(makeNodeComponent("pageLogin")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    buttonSecondary: makeNodeComponent("buttonSecondary"),
    progressBar: makeNodeComponent("progressBar"),
    onboardingContainer: makeNodeComponent("onboardingContainer"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicWebLogin
    internalVariantProps: PlasmicWebLogin__VariantProps,
    internalArgProps: PlasmicWebLogin__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/login",
      pagePath: "/login",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebLogin;
/* prettier-ignore-end */
